import type { RefObject } from 'react';
import type {
	JiraBulkEditMultiSelectFieldOptions,
	main_bulkOperationsCore_FieldSearch$data,
} from '@atlassian/jira-relay/src/__generated__/main_bulkOperationsCore_FieldSearch.graphql';

/* Section - Toolbar types */

export const CheckboxState = {
	CHECKED: 'checked',
	UNCHECKED: 'unchecked',
	INDETERMINATE: 'indeterminate',
} as const;

export type CheckboxState = (typeof CheckboxState)[keyof typeof CheckboxState];

type ExtraAnalyticsAttributes = {
	checkbox: Record<string, unknown>;
	option: Record<string, unknown>;
};

export type ExtraAnalyticsAttributeActions = {
	selectAll?: ExtraAnalyticsAttributes;
	clearAll?: ExtraAnalyticsAttributes;
};

// TODO: remove NoUndefinedOrNull & FieldFragmentRefType types on bulk-transitions-third-iteration_ecc9c cleanup
type NoUndefinedOrNull<T> = Exclude<T, null | undefined>;
export type FieldFragmentRefType = NoUndefinedOrNull<
	NoUndefinedOrNull<
		NoUndefinedOrNull<
			NoUndefinedOrNull<
				NoUndefinedOrNull<
					NoUndefinedOrNull<
						NoUndefinedOrNull<
							main_bulkOperationsCore_FieldSearch$data['jira']
						>['jiraFetchBulkOperationDetails']
					>['bulkEditFields']
				>['edges']
			>[0]
		>['node']
	>['field']
>;

/* Section - Field Search */
export type FieldSearchOptionValue = {
	// TODO: replace FieldFragmentRefType with main_bulkOperationsFormFields_FormField$key on bulk-transitions-third-iteration_ecc9c cleanup
	fragmentRef: FieldFragmentRefType;
	fieldId: string;
	fieldTypeName?: string;
	name: string;
	__typename: string;
	type: string;
	isDuplicated?: boolean;
	isDisabled?: boolean;
	unavailableMessage?: string;
	isMapped: boolean;
	multiSelectFieldOptions?:
		| ReadonlyArray<JiraBulkEditMultiSelectFieldOptions | null | undefined>
		| null
		| undefined;
	displayMessage?: string | null;
	isDefault: boolean;
};

export type FieldSearchOption = {
	label: string;
	value: FieldSearchOptionValue;
	fieldRef?: RefObject<HTMLObjectElement>;
};

export type FieldSearchStatus = 'idle' | 'refetching' | 'error' | 'refetchingEmptyQuery';
